import { createContext, useContext, useReducer, useMemo } from 'react';
import { jsxs as _jsxs } from "react/jsx-runtime";
const initialState = {};
const ReactNodeViewPortalsContext = /*#__PURE__*/createContext({
  portalApi: {
    createPortal: () => {},
    destroyPortal: () => {}
  },
  state: {}
});
const ReactNodeViewPortalsProvider = ({
  children
}) => {
  const [data, dispatch] = useReducer(reducer, initialState);
  const portalApi = useMemo(() => ({
    createPortal(portal) {
      dispatch({
        type: 'createPortal',
        key: portal.key,
        portal
      });
    },
    destroyPortal(key) {
      dispatch({
        type: 'destroyPortal',
        key
      });
    }
  }), []);
  return /*#__PURE__*/_jsxs(ReactNodeViewPortalsContext.Provider, {
    value: {
      portalApi,
      state: data
    },
    children: [children, Object.values(data).map(obj => obj.portal)]
  });
};
function reducer(state, action) {
  switch (action.type) {
    case 'createPortal':
      return Object.assign({}, state, {
        [action.key]: {
          portal: action.portal
        }
      });
    case 'destroyPortal':
      {
        if (!(action.key in state)) {
          return state;
        }
        return Object.assign({}, Object.keys(state).filter(thisKey => thisKey !== action.key).reduce((prev, curr) => Object.assign({}, prev, {
          [curr]: state[curr]
        }), {}));
      }
    default:
      return state;
  }
}
export const useReactNodeViewPortals = () => useContext(ReactNodeViewPortalsContext).portalApi;
export const useReactNodeViewPortalsCount = () => {
  const {
    state
  } = useContext(ReactNodeViewPortalsContext);
  return useMemo(() => Object.keys(state).length, [state]);
};
export default ReactNodeViewPortalsProvider;